/**
 * 🧱 Refactor BT Phase 3 — section « SectionEtapesCreer » de CreerBonTravailDialog.jsx : JSX déplacé TEL QUEL (ex-L1524-1549, dédenté de 10) ;
 * variables via `useBTForm()` (BTFormProvider enrichi par `extra`). DOM, data-testid, classes, textes inchangés.
 */
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Plus, Trash2 } from 'lucide-react';
import { Textarea } from '@/components/ui/textarea';
import { useBTForm } from '../../BTFormContext';

export function SectionEtapesCreer() {
  const {
    addEtape,
    form,
    isExt,
    removeEtape,
    type,
    updateEtape,
  } = useBTForm();
  return (
    <>
      {/* Étapes */}
      <Card>
        <CardHeader>
          <div className="flex justify-between items-center">
            <CardTitle className="text-base">Étapes</CardTitle>
            <Button type="button" size="sm" variant="outline" onClick={addEtape} data-testid="btn-add-etape"><Plus className="w-3 h-3 mr-1" /> Ajouter</Button>
          </div>
        </CardHeader>
        <CardContent>
          {form.etapes.length === 0 ? (
            <p className="text-center text-gray-400 py-4 text-sm">Aucune étape ajoutée</p>
          ) : (
            <div className="space-y-3">
              {form.etapes.map((etape, idx) => (
                <div key={etape.id || etape._id || idx} className="flex gap-2 items-start">
                  <span className="bg-gray-200 text-gray-700 rounded-full w-7 h-7 flex items-center justify-center text-xs font-bold shrink-0 mt-1">{etape.numero}</span>
                  <Textarea value={etape.description} onChange={(e) => updateEtape(idx, e.target.value)} rows={2} className="flex-1"
                    placeholder={isExt ? 'Ex: Enlever toutes les fenêtres (zone 1) et les mettre dans le garage...' : 'Ex: Protéger les planchers et les meubles...'} />
                  <Button type="button" variant="ghost" size="sm" onClick={() => removeEtape(idx)}><Trash2 className="w-4 h-4 text-red-500" /></Button>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>

    </>
  );
}
